import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const UsersAndRolesPage = () => <Guide content={guides.users} />
